import { action } from 'typesafe-actions';

import { AdminUser } from 'models/adminUser';

import { UserResponse, RefreshTokenResponse, AccountResponse } from '../models/user';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESSFUL = 'LOGIN_SUCCESSFUL';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_LOGOUT_SUCCESSFUL = 'USER_LOGOUT_SUCCESSFUL';
export const USER_LOGOUT_FAILURE = 'USER_LOGOUT_FAILURE';

export const REFRESH_TOKEN_REQUEST = 'REFRESH_TOKEN_REQUEST';
export const REFRESH_TOKEN_SUCCESSFUL = 'REFRESH_TOKEN_SUCCESSFUL';
export const REFRESH_TOKEN_FAILURE = 'REFRESH_TOKEN_FAILURE';

export const ACCOUNT_REQUEST = 'ACCOUNT_REQUEST';
export const ACCOUNT_SUCCESSFUL = 'ACCOUNT_SUCCESSFUL';
export const ACCOUNT_FAILURE = 'ACCOUNT_FAILURE';

export const USER_ACCOUNT_DATA = 'USER_ACCOUNT_DATA';

export const USER_LOYALTIES = 'USER_LOYALTIES';

export const REHYDRATE = 'persist/REHYDRATE';

export const OAUTH_EMAIL = 'OAUTH_EMAIL';

export const loginRequest = () => action(LOGIN_REQUEST);
export const loginSuccessful = (login: UserResponse) => action(LOGIN_SUCCESSFUL, login);
export const loginError = (error: string) => action(LOGIN_FAILURE, error);

export const refreshTokenRequest = () => action(REFRESH_TOKEN_REQUEST);
export const refreshTokenSuccessful = (userRefresh: RefreshTokenResponse) =>
  action(REFRESH_TOKEN_SUCCESSFUL, userRefresh);
export const refreshTokenError = (error: string) => action(REFRESH_TOKEN_FAILURE, error);

export const userLogout = () => action(USER_LOGOUT);
export const userLogoutSuccessful = () => action(USER_LOGOUT_SUCCESSFUL);
export const userLogoutError = (error: string) => action(USER_LOGOUT_FAILURE, error);

export const accountRequest = () => action(ACCOUNT_REQUEST);
export const accountSuccessful = (account: AccountResponse) => action(ACCOUNT_SUCCESSFUL, account);
export const accountFailure = (error: string) => action(ACCOUNT_FAILURE, error);

export const userAccountData = (data: AdminUser) => action(USER_ACCOUNT_DATA, data);

export const setOAuthEmail = (data: string) => action(OAUTH_EMAIL, data);
